import { getUserAuthorized } from "helpers/backend_helper"
import React, { useState, cloneElement } from "react"
import { useHistory } from "react-router-dom"
import FullPageLoader from "./FullPageLoader"

const AccessControlWrapper = ({ children, contextUri, actionType }) => {
  const [isChecking, setIsChecking] = useState(false)
  const history = useHistory()

  const handleInteraction = async event => {
    event.preventDefault()
    event.stopPropagation()

    if (isChecking) return

    setIsChecking(true)

    try {
      const hasAccess = await onAccessCheck(contextUri, actionType)
      const { code, desc, type } = hasAccess

      if (
        type === "USER_AUTHORIZATION_STATUS" &&
        desc === "true" &&
        code === "200"
      ) {
        // Access granted - call the original onClick handler
        const originalOnClick = children.props.onClick
        const originalHref = children.props.href
        const originalTo = children.props.to

        if (originalOnClick) {
          // Call the original onClick handler
          originalOnClick(event)
        } else if (originalHref) {
          // Handle link navigation
          if (children.props.target === "_blank") {
            window.open(originalHref, "_blank")
          } else {
            window.location.href = originalHref
          }
        } else if (originalTo) {
          history.push(originalTo)
        }
      } else {
        throw "You do not have permission to perform this action"
      }
    } catch (error) {
      console.error("Access check failed:", error)
      alert("You do not have permission to perform this action.")
    } finally {
      setIsChecking(false)
    }
  }

  async function onAccessCheck(contextUri, actionType) {
    const result = await getUserAuthorized({
      headers: {
        "input-parameters": {
          requestURI: contextUri,
          requestMethod: actionType,
        },
      },
    })
    return result // Make sure this returns true/false
  }

  // Clone the child and replace its onClick with our handler
  const protectedChild = cloneElement(children, {
    onClick: handleInteraction,
    href: children.props.href ? "#" : undefined, // Prevent link navigation
    style: {
      ...children.props.style,
      cursor: isChecking ? "wait" : children.props.style?.cursor || "pointer",
    },
  })

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      {protectedChild}
      <FullPageLoader show={isChecking}  />
    </div>
  )
}

export default AccessControlWrapper
